module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialogCon"
  }, [_c('el-dialog', {
    attrs: {
      "width": "624px",
      "title": "个人中心",
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": function($event) {
        return _vm.submitTap('ruleForm')
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号码:",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off",
      "disabled": ""
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "rgb(187, 187, 187)",
      "height": "28px",
      "line-height": "30px"
    }
  }, [_vm._v("\n          手机号码为了登录账户，不可更改。\n        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "prop": "real_name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入员工昵称",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.real_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "real_name", $$v)
      },
      expression: "form.real_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.sex),
      callback: function($$v) {
        _vm.$set(_vm.form, "sex", $$v)
      },
      expression: "form.sex"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "医师注册号:",
      "prop": "doctor_registration_number",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入医师注册号",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.doctor_registration_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "doctor_registration_number", $$v)
      },
      expression: "form.doctor_registration_number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "头像",
      "prop": "avatar_url",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('uploadImg', {
    attrs: {
      "limit": 1,
      "data": _vm.photoData
    },
    on: {
      "uploads": _vm.uploadData
    },
    model: {
      value: (_vm.form.avatar_url),
      callback: function($$v) {
        _vm.$set(_vm.form, "avatar_url", $$v)
      },
      expression: "form.avatar_url"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitTap('ruleForm')
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "FF7",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01909b4d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/personCenter.vue
// module id = 3493
// module chunks = 103